import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const defaultGetOptionLabel = option => {
  if (option == null) return "";
  if (typeof option === "string") return option;
  return option.name || option.label || option.NOME || String(option.id || "");
};

const SearchableSelect = ({
  options,
  value,
  onChange,
  getOptionLabel,
  getOptionSelected,
  getOptionDisabled,
  label,
  placeholder,
  disabled,
  fullWidth,
  disableClearable,
  noOptionsText,
  TextFieldProps,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Autocomplete
      options={options || []}
      value={value == null ? null : value}
      onChange={(event, next) => onChange(next)}
      getOptionLabel={getOptionLabel || defaultGetOptionLabel}
      getOptionSelected={
        getOptionSelected || ((option, selected) => option === selected)
      }
      getOptionDisabled={getOptionDisabled}
      disabled={disabled}
      fullWidth={fullWidth}
      disableClearable={disableClearable}
      disablePortal
      noOptionsText={noOptionsText || t("ui.select.noOptions")}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          {...TextFieldProps}
        />
      )}
      {...rest}
    />
  );
};

SearchableSelect.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func,
  getOptionSelected: PropTypes.func,
  getOptionDisabled: PropTypes.func,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disableClearable: PropTypes.bool,
  noOptionsText: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  TextFieldProps: PropTypes.object
};

SearchableSelect.defaultProps = {
  options: [],
  value: null,
  getOptionLabel: undefined,
  getOptionSelected: undefined,
  getOptionDisabled: undefined,
  label: undefined,
  placeholder: undefined,
  disabled: false,
  fullWidth: true,
  disableClearable: false,
  noOptionsText: undefined,
  TextFieldProps: undefined
};

export default SearchableSelect;
